import React, { FC, useEffect, useState } from 'react'

import ButtonTabs from 'components/Common/ButtonTabs'
// import ModalBox from 'components/Common/ModalBox'
import {
  AllToolsContainer,
  ConnectedToolsContainer,
  // ToolsGuideContainer,
} from 'pages/Owner/container'
import GrowingContainer from 'components/Common/GrowingContainer'

import { toolsTabs } from 'config'
// import ToolsModalBox from 'components/Owner/Tools/ToolsModalBox'
import ToolsHeader from './ToolsHeader'
// import { navigateTo } from 'utils/helper'
import { useParams } from 'react-router-dom'
import { getRoleFromPath, navigateTo } from 'utils/helper'
import GetHelpCard from './GetHelpCard'
import LetUsKnowCard from './LetUsKnowCard'

interface IToolsProps {
  ownerExperience: string
  updateMyToolsAction: (param: { ownerExperience: string }) => void
}
const Tools: FC<IToolsProps> = ({ ownerExperience, updateMyToolsAction }) => {
  const [selectedTab, setSelectedTab] = useState(toolsTabs[0])
  // As per discussion with kim and arthur we won't need this but instead of removing code whole i am commenting it out
  // const [showModal, setShowModal] = useState(false)
  // const [showToolsGuide, setShowToolsGuide] = useState(false)

  const userRole = getRoleFromPath()

  let { toolSubTab } = useParams()

  useEffect(() => {
    if (!ownerExperience) {
      updateOwnerProfile('experience')
      setSelectedTab(toolsTabs[1])
      navigateTo(userRole, `tools/${toolsTabs[1].link}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ownerExperience])

  useEffect(() => {
    if (ownerExperience) {
      let foundTab = toolsTabs.find((tab) => tab.link === toolSubTab)
      if (foundTab) {
        setSelectedTab(foundTab)
      } else {
        navigateTo(userRole, `tools/${toolsTabs[0].link}`)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolSubTab, userRole])

  const onHandleTabChange = (value) => {
    setSelectedTab(value)
    let foundTab = toolsTabs.find((tab) => tab.label === value.label)
    if (foundTab) {
      navigateTo(userRole, `tools/${foundTab.link}`)
    } else {
      navigateTo(userRole, `tools/${value?.link}`)
    }
  }

  const updateOwnerProfile = (experienceLabel: string) => {
    if (experienceLabel === 'new') {
      updateMyToolsAction({ ownerExperience: 'new' })
      // setShowToolsGuide(false)
      // navigateTo(ROLES.BUSINESS_OWNER,'playbooks')
    } else {
      updateMyToolsAction({ ownerExperience: 'experience' })
      // setShowToolsGuide(false)
      // setShowModal(true)
    }
  }

  return (
    <div className="w-full">
      <ToolsHeader />
      <div className="w-full grid grid-cols-12">
        <div className="xs:col-span-12 sm:col-span-12 md:col-span-12 lg:col-span-12">
          <GrowingContainer className="mt-5">
            <div className="flex items-center justify-between">
              <ButtonTabs
                options={toolsTabs}
                setSelectedTab={onHandleTabChange}
                selectedTab={selectedTab}
              />
            </div>
            <div className="col-span-12 relative z-[5]">
              {selectedTab.label === 'My Tools' && <ConnectedToolsContainer />}
              {selectedTab.label === 'All Tools' && <AllToolsContainer />}
            </div>
          </GrowingContainer>
        </div>
        {/* <div className="xs:col-span-12 sm:col-span-4 md:col-span-5 lg:col-span-4">
          <GrowingContainer className="sm:pl-0 md:pl-0 mdl:pl-0 lg:pl-0">
            <StatsBar completedToolsCount={completedToolsCount} />
            <div className="xs:hidden sm:block ">
              <div className="primary-text text-xl xs:p-1 sm:p-2  lg:p-10 font-primary">
                <p className="mb-6 font-primary">
                  In the All Tools tab, you can find the technology tools your business already uses
                  and connect them easily to GoTackle.
                </p>
                <p>
                  Need help picking the right technology for your business? Complete an assessment
                  to get a Playbook with step-by-step guidance on getting started with the right
                  tool.
                </p>
              </div>
              <div className="text-center">
                <img className="w-full max-w-[190px] my-9 mx-auto" src={techImg} alt="techImg" />
              </div>
            </div>
          </GrowingContainer>
        </div>
        <div className="col-span-12">
          {isMobileOnly && (
            <GrowingContainer>
              <div>
                <div className="col-span-12 items-center justify-between">
                  <ButtonTabs
                    options={toolsTabs}
                    setSelectedTab={onHandleTabChange}
                    selectedTab={selectedTab}
                  />
                  <div className="col-span-12 relative z-[5] xs:-mt-2 md:-mt-3 lg:-mt-5">
                    {selectedTab.label === 'My Tools' && <ConnectedToolsContainer />}
                    {selectedTab.label === 'All Tools' && <AllToolsContainer />}
                  </div>
                </div>
              </div>
            </GrowingContainer>
          )}
        </div> */}
      </div>

      {/* As per discussion with kim and arthur we won't need this but instead of removing whole code i am commenting it out */}
      {/* {showToolsGuide && (
        <ModalBox
          classes="rounded-xl"
          width="w-full flex justify-center items-center h-screen"
          backgroundColor="bg-transparent"
        >
          <ToolsGuideContainer updateOwnerProfile={updateOwnerProfile} />
        </ModalBox>
      )}
      <ToolsModalBox setShowModal={setShowModal} showModal={showModal} /> */}
      <div className="sm:hidden mt-12 space-y-10">
        <GetHelpCard />
        <LetUsKnowCard />
      </div>
    </div>
  )
}

export default Tools
